export default __webpack_public_path__ + "static/media/DSC_7399.9a750a26.jpg";